import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.ROUTER_BASE,
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/',
      redirect: '/24dtxs'
    },
    {
      path: '/24dtxs',
      name: '24dtxs',
      component: () => import('@/views/pages/index'),
      meta: {
        pageTitle: '对话历史·美育未来'
      }
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('@/views/pages/news/index'),
      meta: {
        pageTitle: '活动快讯'
      }
    },
    {
      path: '/cultural/:type',
      name: 'cultural',
      component: () => import('@/views/pages/news/cultural'),
      meta: {
        pageTitle: '文旅专区'
      }
    },


    {
      path: '/newsDetail/:id',
      component: () => import('@/views/pages/news/detail'),
      name: 'newsDetail',
      meta: { pageTitle: '资讯详情', icon: 'app', noCache: true }
    },
    {
      path: '/sjcwlist/:type?',
      name: 'sjcwlist',
      component: () => import('@/views/pages/sjcwlist'),
      meta: {
        pageTitle: '美育课堂'
      }
    },
    {
      path: '/sjcwDetail/:index',
      name: 'sjcwDetail',
      component: () => import('@/views/pages/pic_detail/sjcw'),
      meta: {
        pageTitle: '美育课堂详情'
      }
    },
    {
      path: '/picshow/:type?',
      name: 'picshow',
      component: () => import('@/views/pages/picshow'),
      meta: {
        pageTitle: '大唐西市',
        keepAlive: true
      }
    },

    {
      path: '/dnkcwDetail/:ocCode/:type/:teamCode/:className?',
      name: 'dnkcwDetail',
      component: () => import('@/views/pages/pic_detail/dnkcw'),
      meta: {
        pageTitle: '详情'
      }
    },
    {
      path: '/pic_detail/:ocCode/:sortIndex/:teamCode/:ocName?/:searchSort',
      name: 'pic_detail',
      component: () => import('@/views/pages/pic_detail/index'),
      meta: {
        pageTitle: '视频详情'
      }
    },
    {
      path: '/img_detail/:ocCode/:sortIndex/:teamCode/:ocName?/:searchSort',
      name: 'img_detail',
      component: () =>
        import('@/views/pages/img_detail/index'),
      meta: {
        pageTitle: '图片详情'
      }
    },
    {
      path: '/monselect/:type?',
      name: 'monselect',
      component: () => import('@/views/pages/monselect'),
      meta: {
        pageTitle: '全民美育',
        keepAlive: true
      }
    },
    {
      path: '/zajmDetail/:ocCode',
      name: 'zajmDetail',
      component: () => import('@/views/pages/pic_detail/zajm'),
      meta: {
        pageTitle: '非遗传承详情',
        keepAlive: true
      }
    },
    {
      path: '/village',
      name: 'village',
      component: () => import('@/views/pages/village'),
      meta: {
        pageTitle: '多元实践',
        keepAlive: true
      }
    },

    {
      path: '/resultview',
      name: 'resultview',
      component: () => import('@/views/pages/resultview'),
      meta: {
        pageTitle: '结果公示'
      }
    },
    {
      path: '/worksubmit',
      name: 'worksubmit',
      component: () => import('@/views/pages/worksubmit/index'),
      meta: {
        pageTitle: '信息填写'
      }
    },

    {
      path: '/login',
      component: () => import('@/views/login/login'),
      name: 'login',
      meta: { pageTitle: '登录页', icon: 'app', noCache: true }
    },
    // -------------------------------后台--资讯-----------------------------
    {
      path: '/newslist',
      component: () => import('@/views/newslist/news'),
      name: 'newslist',
      meta: { pageTitle: '活动快讯', icon: 'app', noCache: true }
    },
    {
      path: '/addNews',
      component: () => import('@/views/newslist/add'),
      name: 'addNews',
      meta: { pageTitle: '新增', icon: 'app', noCache: true, activeMenu: '/newslist' }
    },
    {
      path: '/editNews/:id',
      component: () => import('@/views/newslist/edit'),
      name: 'editNews',
      meta: { pageTitle: '编辑', icon: 'app', noCache: true, activeMenu: '/newslist' }
    },
    // -------------------------------后台--多元文化-----------------------------
    {
      path: '/culturelist',
      component: () => import('@/views/culturelist/news'),
      name: 'culturelist',
      meta: { pageTitle: '多元文化', icon: 'app', noCache: true }
    },
    {
      path: '/addculture',
      component: () => import('@/views/culturelist/add'),
      name: 'addculture',
      meta: { pageTitle: '新增', icon: 'app', noCache: true, activeMenu: '/culturelist' }
    },
    {
      path: '/editculture/:id',
      component: () => import('@/views/culturelist/edit'),
      name: 'editculture',
      meta: { pageTitle: '编辑', icon: 'app', noCache: true, activeMenu: '/culturelist' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js